import axios from 'axios';

const API_URL = 'https://localhost:7178/WeatherForecast';

export const getWeatherForecast = async () => {
    try {
        const response = await axios.get(API_URL);
        return response.data;    
    } catch (error) {
        console.error('Error fetching weather forecast:', error);
        throw error;
    }
};